import React from 'react';
import { Route, IndexRoute } from 'react-router';
import URLHelpers from '../components/shared/url_helpers';

const {
  coreIdentityVerificationPath,
  lpIdentityVerificationPath,
  coreBankAccountVerificationPath,
  lpBankAccountVerificationPath,
  corePhotoIDVerificationPath,
  lpPhotoIDVerificationPath,
  coreCompanyDataVerificationPath,
  lpCompanyDataVerificationPath,
  coreShopOwnerVerificationPath,
  coreBankAccountPath,
  lpShopOwnerVerificationPath,
} = URLHelpers;

export const CoreIdentityVerificationRoute = (
  <Route
    key={coreIdentityVerificationPath}
    path={coreIdentityVerificationPath}
    getComponent={(_location, cb) => {
      import(
        /* webpackChunkName: 'onboarding' */
        '../identity_verification/identity_verification_container'
      ).then(m => cb(null, m.default));
    }}
  >
    <IndexRoute
      getComponent={(_location, cb) => {
        import(
          /* webpackChunkName: 'onboarding' */
          '../identity_verification/statuses_index'
        ).then(m => cb(null, m.default));
      }}
    />
    <Route
      key={coreBankAccountVerificationPath}
      path={coreBankAccountVerificationPath}
      getComponent={(_location, cb) => {
        import(
          /* webpackChunkName: 'onboarding' */
          '../identity_verification/bank_account_verification'
        ).then(m => cb(null, m.default));
      }}
    />
    <Route
      key={corePhotoIDVerificationPath}
      path={corePhotoIDVerificationPath}
      getComponent={(_location, cb) => {
        import(
          /* webpackChunkName: 'onboarding' */
          '../identity_verification/photo_id_verification'
        ).then(m => cb(null, m.default));
      }}
    />
    <Route
      key={coreShopOwnerVerificationPath}
      path={coreShopOwnerVerificationPath}
      getComponent={(_location, cb) => {
        import(
          /* webpackChunkName: 'onboarding' */
          '../identity_verification/shop_owner_verification'
        ).then(m => cb(null, m.default));
      }}
    />
    <Route
      key={coreCompanyDataVerificationPath}
      path={coreCompanyDataVerificationPath}
      getComponent={(_location, cb) => {
        import(
          /* webpackChunkName: 'onboarding' */
          '../identity_verification/update_company_form'
        ).then(m => cb(null, m.default));
      }}
    />
    <Route
      key={coreBankAccountPath}
      path={coreBankAccountPath}
      getComponent={(_location, cb) => {
        import(
          /* webpackChunkName: 'onboarding' */
          '../identity_verification/update_bank_account_form'
        ).then(m => cb(null, m.default));
      }}
    />
  </Route>
);

export const LPIdentityVerificationRoute = (
  <Route
    key={lpIdentityVerificationPath}
    path={lpIdentityVerificationPath}
    getComponent={(_location, cb) => {
      import(
        /* webpackChunkName: 'onboarding' */
        '../identity_verification/identity_verification_container'
      ).then(m => cb(null, m.default));
    }}
  >
    <IndexRoute
      getComponent={(_location, cb) => {
        import(
          /* webpackChunkName: 'onboarding' */
          '../identity_verification/statuses_index'
        ).then(m => cb(null, m.default));
      }}
    />
    <Route
      key={lpBankAccountVerificationPath}
      path={lpBankAccountVerificationPath}
      getComponent={(_location, cb) => {
        import(
          /* webpackChunkName: 'onboarding' */
          '../identity_verification/bank_account_verification'
        ).then(m => cb(null, m.default));
      }}
    />
    <Route
      key={lpPhotoIDVerificationPath}
      path={lpPhotoIDVerificationPath}
      getComponent={(_location, cb) => {
        import(
          /* webpackChunkName: 'onboarding' */
          '../identity_verification/photo_id_verification'
        ).then(m => cb(null, m.default));
      }}
    />
    <Route
      key={lpCompanyDataVerificationPath}
      path={lpCompanyDataVerificationPath}
      getComponent={(_location, cb) => {
        import(
          /* webpackChunkName: 'onboarding' */
          '../identity_verification/update_company_form'
        ).then(m => cb(null, m.default));
      }}
    />
    <Route
      key={lpShopOwnerVerificationPath}
      path={lpShopOwnerVerificationPath}
      getComponent={(_location, cb) => {
        import(
          /* webpackChunkName: 'onboarding' */
          '../identity_verification/shop_owner_verification'
        ).then(m => cb(null, m.default));
      }}
    />
  </Route>
);
